<!--
Author: TangChen
Date: 2018-12-25
Desc: 用户持有的私募基金/专户理财资产展示
 -->
<template>
    <div :class="'bizcomp-my-private bizcomp ' + className">
        <comp-title :title="title" />
        <el-row class="my-private">
            <el-col v-if="projectType==='1'" :span="9">
                <i class="private-icon" />
                <div class="icon-text">
                    <div v-cloak class="red private-data">
                        {{ getInvestor(privateInfo.isaccreditedinvestor) }}投资者<span class="like-a" v-on:click.once="$router.push({name:'privateupload'})">[重新鉴定]</span>
                    </div>
                    <div>合格投资者状态</div>
                </div>
            </el-col>
            <el-col :span="projectType==='1'?9:18">
                <i class="private-icon assets" />
                <div class="icon-text">
                    <div>专户理财总资产(元){{ projectType==='0'?'：':'' }}<span v-if="projectType==='0'" v-cloak class="private-data red">{{ $util.fmtNum(privateInfo.totalasset) }}</span></div>
                </div>
            </el-col>
            <el-col :span="6" class="btn-buy">
                <el-button type="blue" v-on:click.once="$router.push({name:'privatefund'})">
                    <i class="private-btn-icon" />购买专户理财产品
                </el-button>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
    name: "MyPrivate",
    mixins: [mixin],
    data () {
        return {
            projectType: "", // 项目类型，直销or代销
            privateInfo: {}
        };
    },
    mounted () {
        this.projectType = this.$cache.getParams().ix_zx == "1" ? "0" : "1";
        this.getPrivateInfo();
    },
    methods: {
        getPrivateInfo () {
            const _self = this;
            this.$util.request("pef/asset/total").then(res => {
                if (res.data) {
                    _self.privateInfo = res.data[0];
                }
            });
        },
        // 获取投资者状态
        getInvestor (val) {
            let _x = "";
            switch (val) {
            case "0":
                _x = "不合格";
                break;
            case "1":
                _x = "合格";
                break;
            case "2":
                _x = "豁免合格";
                break;
            case "3":
                _x = "未鉴定";
                break;
            default:break;
            }
            return _x;
        }
    }
};
</script>
<style lang="scss">
  @import '../../assets/css/varibles';
  .bizcomp-my-private {
    .my-private {
      padding: 22px 20px;
      background-color: $bg5;
      .private-icon {
        width: 54px;
        height: 54px;
        margin-right: 16px;
        border-radius: 50%;
        background-color: $color-a;
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        &:before{
          content: "";
          margin-top: 8px;
          display: inline-block;
          width: 32px;
          height: 36px;
          background: url($icon) -360px -182px no-repeat;
        }
        &.assets{
          background-color: $color-c;
          &:before{
            background: url($icon) -361px -128px no-repeat;
          }
        }
      }
      .icon-text{
        display: inline-block;vertical-align: middle;
        div{
          color: $text-color2;
          &.red,.red {
            color: $color-c;
          }
          &.private-data,.private-data{
            font-size: $f22;
            .like-a{font-size: $f14;margin-left: 5px;}
          }
        }
      }
      .btn-buy {
        text-align: right;
        .el-button {
          margin-top: 5px;
          padding: 8px 12px;
          .private-btn-icon {
            width: 22px;
            height: 22px;
            display: inline-block;
            background: url($icon) -105px 0;
            vertical-align: middle;
            margin-right: 10px;
          }
        }
      }
    }
  }
</style>
